import React from "react";
import { Dialog } from "../../../base/dialog";
const AudioRoutePicker = React.memo(() => {
    return (React.createElement(Dialog, null, "audio trout"));
});
export default AudioRoutePicker;
